import Vue from "vue";
import FusenGroup from "./FusenGroup.vue";
export default Vue.extend({
    data: function () {
        return {
            dragging: "none",
            resizeType: [],
            dragOffset: {
                x: 0,
                y: 0
            },
        };
    },
    computed: {
        selectedItem: function () {
            return this.$store.state.items[this.$store.state.selectedIndex];
        },
        items: function () {
            return this.$store.state.items;
        },
        handles: function () {
            var item = this.selectedItem;
            if (!item) {
                return [];
            }
            var size = 10;
            /*
              lt ct rt
              lc    rc
              lb cb rb
            */
            return [
                { type: ["left", "top"], x: 0, y: 0, size: size },
                { type: ["center", "top"], x: item.w / 2, y: 0, size: size },
                { type: ["right", "top"], x: item.w, y: 0, size: size },
                { type: ["left", "center"], x: 0, y: item.h / 2, size: size },
                { type: ["right", "center"], x: item.w, y: item.h / 2, size: size },
                { type: ["left", "bottom"], x: 0, y: item.h, size: size },
                { type: ["center", "bottom"], x: item.w / 2, y: item.h, size: size },
                { type: ["right", "bottom"], x: item.w, y: item.h, size: size },
            ];
        },
        connectorPath: function () {
            var items = this.items;
            var start = {
                x: items[0].x + items[0].w,
                y: items[0].y + items[0].h / 2,
            };
            var end = {
                x: items[1].x,
                y: items[1].y + items[1].h / 2,
            };
            var handleLength = 50;
            if (items.length > 0) {
                return "M" + start.x + "," + start.y + " C" + (start.x + handleLength) + "," + start.y + " " + (end.x - handleLength) + "," + end.y + " " + end.x + "," + end.y;
            }
            return "";
        }
    },
    methods: {
        resizePoint: function (type) {
            this.dragging = "resize";
            this.resizeType = type;
        },
        startDrag: function (ev) {
            var e = ev[0];
            var index = ev[1];
            this.dragging = "move";
            this.$store.commit("selectItem", index);
            //ページ左上とオブジェクト左上の差分から、ドラッグ開始位置（オブジェクト相対座標）を取得
            this.dragOffset.x = e.offsetX - this.selectedItem.x;
            this.dragOffset.y = e.offsetY - this.selectedItem.y;
        },
        onResize: function (e) {
            var move = {
                x: this.selectedItem.x,
                y: this.selectedItem.y,
                w: this.selectedItem.w,
                h: this.selectedItem.h
            };
            if (this.resizeType[0] === "left") {
                move.x = gridRound(e.offsetX);
                move.w = move.w - move.x + this.selectedItem.x;
            }
            if (this.resizeType[0] === "right") {
                move.w = gridRound(e.offsetX - this.selectedItem.x);
            }
            if (this.resizeType[1] === "bottom") {
                move.h = gridRound(e.offsetY - this.selectedItem.y);
            }
            if (this.resizeType[1] === "top") {
                move.y = gridRound(e.offsetY);
                move.h = move.h - move.y + this.selectedItem.y;
            }
            this.$store.commit("resizeItem", move);
        },
        onDrag: function (e) {
            if (this.dragging === "move") {
                //差分値を基点に反映
                this.$store.commit("moveItem", {
                    x: gridRound(e.offsetX - this.dragOffset.x),
                    y: gridRound(e.offsetY - this.dragOffset.y)
                });
            }
            if (this.dragging === "resize") {
                this.onResize(e);
            }
        },
        stopDrag: function () {
            if (this.dragging !== "none") {
                this.dragging = "none";
                //this.$store.commit("selectItem", -1);
            }
        },
        openEditor: function (index) {
            this.$store.commit("openEditor", index);
        }
    },
    components: {
        FusenGroup: FusenGroup
    }
});
function gridRound(value) {
    return Math.round(value / 8) * 8;
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/FusenCanvas.vue
// module id = 13
// module chunks = 0